/* esm.sh - @smithy/util-base64@4.4.3 */
import{fromBase64 as r,toBase64 as a}from"@smithy/core/serde";export{r as fromBase64,a as toBase64};
//# sourceMappingURL=util-base64.mjs.map